import React, { Component } from "react";
import { config } from "../../config/config";
import { withAppState, getAppState } from "../../state";
import { autologin } from "../../services/authenticationService";
import { SplashStyled, ContainerStyled, LogoStyled, LoadingStyled } from "./styles/Styled";
import { getSdk } from "../../services/sdkService";
import {
  checkVoucherEligiblity,
  checkYearEligibility,
  checkAlreadyRedeemed
} from "../../services/eVoucherEligibilityService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { routes } from "../../routes";
import { showForceLogoutError } from "../../services/modalsService";
import FreeLogo from "../../components/FreeLogo";

// FIXME: Setting timeout to artificially cause the Splash screen to be displayed for a while
// Once we do more stuff during the splash screen, the timer won't be necessary
const TEMPORARY_DELAY = 3000;

class Splash extends Component {
  constructor(props) {
    super(props);
    this.isVoucherActive = null;
    this.checkUserLogged = this.checkUserLogged.bind(this);
    this.setVoucherEligibility = this.setVoucherEligibility.bind(this);
    this.proceedNavigation = this.proceedNavigation.bind(this);
  }

  async componentDidMount() {
    this.props.pauseNavigation();
    await config.get();
    // force logout checks
    if (!!getAppState().forceLogout) {
      this.props.resumeNavigation();
      showForceLogoutError.call(this);
      return;
    }
    this.props.applicationState.appStarted === false && (await this.setVoucherEligibility());
    await this.proceedNavigation();
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
  }

  async proceedNavigation() {
    const {
      history,
      applicationState,
      stateActions: { getHomePath, setAppStartedValue }
    } = this.props;
    const isUserLoggedIn = await this.checkUserLogged();
    let path = !!this.isVoucherActive ? routes.landing : !isUserLoggedIn ? routes.welcome : getHomePath();

    try {
      const platform = await getSdk().systemManager.device.getPlatform();
      if (
        platform === "tizen" &&
        applicationState.showPromotionPage &&
        (await checkYearEligibility()) &&
        (await checkAlreadyRedeemed())
      ) {
        path = !isUserLoggedIn ? routes.welcome : getHomePath();
      }
    } catch (error) {
      console.log(error);
    }

    !!this.isVoucherActive && setAppStartedValue();
    setTimeout(() => history.replace(path), TEMPORARY_DELAY);
  }

  async checkUserLogged() {
    const { stateActions } = this.props;
    const loggedIn = await autologin();
    if (loggedIn) {
      stateActions.userLoggedIn(loggedIn);
      const sdk = await getSdk();
      sdk.userManager.getDevices();
      sdk.userManager.getPreferences();
      return true;
    }
    return false;
  }

  async setVoucherEligibility() {
    const voucherEligibility = await checkVoucherEligiblity();
    this.isVoucherActive = !!voucherEligibility;
  }

  render() {
    return (
      <SplashStyled>
        <ContainerStyled>
          <LogoStyled>
            <FreeLogo height="3.43rem" />
          </LogoStyled>
          <LoadingStyled />
        </ContainerStyled>
      </SplashStyled>
    );
  }
}

export default withAppState(withSubtheme(Splash));
